import React from 'react';
import { Download, Printer, Shuffle } from 'lucide-react';
const auditEvents = [{
  id: '1',
  date: '1/15/2026',
  time: '3:45 PM',
  decision: 'Approved',
  creditLimit: '$100,000',
  paymentTerms: 'Net 30',
  reasoning: 'Strong financials and excellent payment history',
  eventType: 'Credit Decision',
  user: 'Sarah Chen'
}, {
  id: '2',
  date: '1/10/2026',
  time: '2:30 PM',
  decision: '--',
  creditLimit: '--',
  paymentTerms: '--',
  reasoning: '--',
  eventType: 'Recommendation Generated',
  user: 'System Note'
}, {
  id: '3',
  date: '1/10/2026',
  time: '11:45 AM',
  decision: '--',
  creditLimit: '--',
  paymentTerms: '--',
  reasoning: '--',
  eventType: 'Application Matched to Report',
  user: 'System Note'
}, {
  id: '4',
  date: '1/10/2026',
  time: '9:30 AM',
  decision: '--',
  creditLimit: '--',
  paymentTerms: '--',
  reasoning: '--',
  eventType: 'Application Submitted',
  user: 'Charlie Bucket'
}];
export function WonkaAuditLogTab() {
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3330">
      {/* Header */}
      <div className="p-6 border-b border-gray-200" data-id="element-3331">
        <div className="flex items-center justify-between mb-4" data-id="element-3332">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-3333">
            Credit Decision Audit Log
          </h2>
          <div className="flex items-center gap-3" data-id="element-3334">
            <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-3335">
              <Download className="w-5 h-5 text-gray-600" data-id="element-3336" />
            </button>
            <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-3337">
              <Printer className="w-5 h-5 text-gray-600" data-id="element-3338" />
            </button>
            <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-3339">
              <Shuffle className="w-5 h-5 text-gray-600" data-id="element-3340" />
            </button>
          </div>
        </div>
        <div className="flex items-center justify-between" data-id="element-3341">
          <div className="flex items-center gap-4" data-id="element-3342">
            <select className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 bg-white" data-id="element-3343">
              <option data-id="element-3344">Filter by Event Type</option>
              <option data-id="element-3345">Application Submitted</option>
              <option data-id="element-3346">Application Matched to Report</option>
              <option data-id="element-3347">Recommendation Generated</option>
              <option data-id="element-3348">Credit Decision</option>
            </select>
            <select className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 bg-white" data-id="element-3349">
              <option data-id="element-3350">Filter by User</option>
              <option data-id="element-3351">Sarah Chen</option>
              <option data-id="element-3352">Charlie Bucket</option>
              <option data-id="element-3353">System Note</option>
            </select>
          </div>
          <div className="flex items-center gap-2" data-id="element-3354">
            <span className="text-sm text-gray-600" data-id="element-3355">Date Range</span>
            <input type="text" placeholder="MM/DD/YYYY – MM/DD/YYYY" className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 w-64" data-id="element-3356" />
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto" data-id="element-3357">
        <table className="w-full text-left border-collapse" data-id="element-3358">
          <thead data-id="element-3359">
            <tr className="bg-gray-50 border-b border-gray-200" data-id="element-3360">
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3361">
                Date
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3362">
                Decision
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3363">
                Credit Limit
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3364">
                Payment Terms
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3365">
                Reasoning
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3366">
                Event Type
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3367">
                User
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-3368">
            {auditEvents.map(event => <tr key={event.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-3369">
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3370">
                  {event.date}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3371">
                  {event.decision}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3372">
                  {event.creditLimit}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3373">
                  {event.paymentTerms}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3374">
                  {event.reasoning}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3375">
                  {event.eventType}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3376">
                  {event.user}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}